import {
  ColumnOptionsBase,
  EntityColumn,
  entityColumn,
  GridRef,
  GroupColumnRef,
  ServerSideColumnOption,
  stringColumn
} from '@softapps/core';
import { MainGroup } from './main-group';
import { Signal } from '@angular/core';
import { Translation } from '@softline/ui-core';
import { MainGroupColumnComponent } from './main-group-column.component';

export interface ClientSideMainGroupColumnOptions<TRow extends object> extends ColumnOptionsBase<TRow, MainGroup> {
  rowGroup?: boolean;
}

export interface ServerSideMainGroupColumnOptions<TRow extends object> extends ColumnOptionsBase<TRow, MainGroup>, ServerSideColumnOption {
  rowGroup?: boolean;
}

export type MainGroupColumnOptions<TRow extends object> = ClientSideMainGroupColumnOptions<TRow> | ServerSideMainGroupColumnOptions<TRow>;

export function mainGroupColumn<TRow extends object>(ref: GridRef<TRow> | GroupColumnRef<TRow>,
                                                 translator: (key: string) => Signal<Translation>,
                                                 options: MainGroupColumnOptions<TRow>): EntityColumn<TRow, MainGroup>{
  return entityColumn(ref, {
    ...options,
    format: v => `${v.arthauptgrp} - ${v.bezeichnung}`,
    sortBy: v => v.arthauptgrp,
    cellRenderer: MainGroupColumnComponent,
    serverSideSortField: 'arthauptgrp',
  }, entityRef => {
    stringColumn(entityRef, {
      colId: 'number',
      header: translator('Hauptgruppe'),
      getValue: v => v.arthauptgrp
    });
    stringColumn(entityRef, {
      colId: 'name',
      header: translator('Name'),
      getValue: v => v.bezeichnung
    });
  });
}
